import { timeFormatter } from '@/helpers/timeFormatter'

export default {
    data () {
        return {
            timerState: {
                seconds: 0
            },
            timerOptions: {
                interval: 1000,
                realtime: false
            },
            timerInterval: null
        }
    },
    computed: {
        timerDisplayTime () {
            return timeFormatter(
                this.timerState.seconds,
                this.timerOptions.realtime
            )
        },
    },
    methods: {
        getTimerValue () {
            return 0
        },
        resetTimer () {
            this.timerState.seconds = 0
        },
        setTimerValue (value) {
            this.timerState.seconds = value
        },
        startTimer () {
            if (this.timerInterval) {
                clearInterval(this.timerInterval)
            }

            this.timerInterval = setInterval(
                () => {
                    this.timerState.seconds = this.getTimerValue()
                },
                this.timerOptions.timerInterval || 1000
            )
        },
        stopTimer () {
            clearInterval(this.timerInterval)
        },
        destroyTimer () {
            clearInterval(this.timerInterval)
        }
    },
    beforeDestroy () {
        this.destroyTimer()
    }
}
